package pwgs.ui.scenes.analyticsdashboardscene


class AnalyticsDashboardControllerFe(props: AnalyticsDashboardSceneProps, scene: MAnalyticsDashboardScene) : AAnalyticsDashboardControllerFe(props, scene) {

    override fun createInitialModel() : AnalyticsDashboardSceneModel {
        return AnalyticsDashboardSceneModel(AnalyticsDashboardRealtimeStatsModel(0, 0, 0, 0), listOf())
    }

    override fun init() {
        call_load()
    }

    fun refreshRealtimeStats() {
        call_refreshRealtimeStats()
    }


}

